import { _ } from "../../../../core/polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";
import jQuery from "jquery";
import ReportTableWidget from "../../../reports2/ReportTableWidget/ReportTableWidget.js";

/**
 * `condensedStatementWidget` is a condensed table used to display
 * statement in a report while not taking too much space.
 *
 * @param {object} spec - Parameter object
 * @param {Renderable[]} [spec.headers] - Array of renderables to display as column headers
 * @param {string} [spec.cssClass] - Optional CSS class.
 * @param {boolean} [spec.formatInThousands] - To force the value to be displayed as thousands
 * @param {string} spec.cultureCode - MS culture code (format 'sv-SE') used to format the values
 * @param {*} my - protected fields holder
 * @return {widget}
 */
function condensedStatementWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);
	const extraCssClass = spec.cssClass;

	let report = null;

	that.setReport = function (newReport) {
		report = newReport;
		that.update();
	};

	that.renderContentOn = function (html) {
		html.div({ klass: extraCssClass || "" }, (html) => {
			if (!report || report.isEmpty()) {
				my.renderEmptyOn(html);
				return;
			}

			const reportTableWidget = new ReportTableWidget({
				report,
				isFlat: true,
			});

			html.div(
				{ klass: "report-condensed-statement" },
				reportTableWidget,
			);
		});
	};

	my.renderEmptyOn = function (html) {
		html.render(_("No data"));
	};

	my.didAttach = function () {
		jQuery('[data-toggle="tooltip"]').tooltip();
	};

	return that;
}

export default condensedStatementWidget;
